import axiosIns from "@/api/axios";

export const GET_APP = () => {
    return axiosIns.get(`/app`);
};

export const GET_ACTIVE = () => {
    return axiosIns.get('/clientActive')
}

export const GET_ROLES = (args) => {
    return axiosIns.get(`/app/roles?${args}`);
};

export const GET_COMPANY = (args) => {
    return axiosIns.get(`/company?${args}`);
};

export const GET_COMPANY_DEPARTMENT = (args) => {
    return axiosIns.get(`/company/detail?${args}`);
};

export const ADD_DATA = (args) => {
    return axiosIns.post(`/generate`, args);
};
export const GET_VARIABLES = (args) => {
    return axiosIns.get(`/app-variables?${args}`);
};
export const ADD_VARIABLES = (args) => {
    return axiosIns.post(`/app-variables`, args);
};

export const UPDATE_VARIABLES = (args) => {
    return axiosIns.put(`/app-variables?id=${args.id}`, args)
}
export const DEL_VARIABLES = (id) => {
    return axiosIns.delete(`/app-variables?id=${id}`)
}

